module.exports = __webpack_public_path__ + "media/images/icons/corporate_customers-5bb726e49445f2244736c3d6e98dfa7d.svg";